import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppConstatnts } from 'src/app/common/constants/app-contstants';
import { EditorMode, MultimediaTypes, NotifierEvents, PopupOpenMode, PopupViewMode, ReferenceType } from 'src/app/common/enums/enums';
import { EditorReferenceInfo } from 'src/app/common/models/editors/editor-reference-info';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { environment } from 'src/environments/environment';
import { IndividualApiService } from 'src/app/services/API/individual-api.service';
import { ResponseModel } from 'src/app/common/models/responseModel';
import { IndividualViewBase } from 'src/app/common/models/individual/individual-view-base';
import { RootMember } from 'src/app/common/models/RootMember';
import { ProjectRefService } from 'src/app/services/project-ref.service';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { TranslateService } from '@ngx-translate/core';
import { UserModel } from 'src/app/common/models/UserModel';
import { Subscription } from 'rxjs';
import { ComponentBase } from '../../common/base/component-base';
import { filter } from 'rxjs/operators';
import { UploadStateService } from 'src/app/services/upload-state.service';
import { UserUpdateService } from 'src/app/services/user-update.service';

@Component({
  selector: 'app-menu-main',
  templateUrl: './menu-main.component.html',
  styleUrls: ['./menu-main.component.scss']
})



export class MenuMainComponent extends ComponentBase implements OnInit, OnDestroy {
  @Input() loadingState: boolean = false;
  searchResults: { data: IndividualViewBase[], projectId: string } = { data: [], projectId: "" };
  expectedUpdates = [NotifierEvents.RootMemberChanged, NotifierEvents.RootMemberUpdated];
  isHideSearchLoading = false;
  userName = "";
  userDataSubscription: Subscription
  firstLetterOfName = "";
  isRegenerateEnabled = false;
  activeEditorMode: EditorMode | null = null;
  email = "";
  showSupportPopup = false;
  isUploading = false;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private dialogService: DialogService,
    protected notifierService: NotifierV2Service,
    private individualAPIService: IndividualApiService,
    private projectRefService: ProjectRefService,
    private translateHandler: TranslateHandler,
    private translateService: TranslateService,
    private uploadState: UploadStateService,
    private userUpdateService: UserUpdateService) {

    super(notifierService);
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateActiveEditorByRoute(event.urlAfterRedirects);
      });
  }

  ngOnInit(): void {
    if (this.uploadState && this.uploadState.uploading$) {
      this.uploadState.uploading$.subscribe(state => {
        this.isUploading = state;
      });
    }
    this.setUsername();
    this.userUpdateService.userName$.subscribe(name => {
      if (name) {
        this.setUsername();
      }
    });
  }

  private updateActiveEditorByRoute(url: string) {
    if (url.includes(AppConstatnts.routerModes.TreeEditor)) {
      this.activeEditorMode = this.getEditorModes().TreeEditor;
    } else if (url.includes(AppConstatnts.routerModes.IndividualEditor)) {
      this.activeEditorMode = this.getEditorModes().IndividualEditor;
      this.isRegenerateEnabled = true;
    } else if (url.includes(AppConstatnts.routerModes.FamilyEditor)) {
      this.activeEditorMode = this.getEditorModes().FamilyEditor;
    } else if (url.includes(AppConstatnts.routerModes.SourceEditor)) {
      this.activeEditorMode = this.getEditorModes().SourceEditor;
    } else if (url.includes(AppConstatnts.routerModes.PlaceEditorPage)) {
      this.activeEditorMode = this.getEditorModes().PlaceEditorPage;
    }
    else {
      this.activeEditorMode = null;
    }
  }

  route(routeName) {

    let ref: EditorReferenceInfo = { id: 0, isBreadcrumbUpdate: true };

    // Family editor
    if (AppConstatnts.routerModes[routeName] == AppConstatnts.routerModes.FamilyEditor) {
      ref = {
        id: this.notifierService.getCurrentRootFamilyId(),
        isBreadcrumbUpdate: true
      }
      this.notifierService.openEditor(EditorMode.FamilyEditor, ref);
      return;
    }
    if (AppConstatnts.routerModes[routeName] == AppConstatnts.routerModes.IndividualEditor) {
      ref = {
        id: this.notifierService.getCurrentRootMemberId(),
        isBreadcrumbUpdate: true
      }
      this.notifierService.openEditor(EditorMode.IndividualEditor, ref);
      return;
    }
    //Tree Editor, change @EM-10562
    if (AppConstatnts.routerModes[routeName] == AppConstatnts.routerModes.TreeEditor) {
      this.router.navigate([AppConstatnts.routerModes[routeName], this.notifierService.getCurrentRootMemberId(), true])
      return;
    }
    if (AppConstatnts.routerModes[routeName] == AppConstatnts.routerModes.PlaceEditorPage) {
      ref = {
        isBreadcrumbUpdate: true
      }
      this.notifierService.openEditor(EditorMode.PlaceEditorPage, ref);
      return;
    }
    this.router.navigate([AppConstatnts.routerModes[routeName]])
  }

  isDisabled() {
    //return true;
    return !this.projectRefService.isCurrentProjectEditable();
  }
  setUsername() {
    const cached = this.authenticationService.getCookieUserName();
    if (cached && Object.keys(cached).length > 0) {
      this.userName = `${cached.firstName} ${cached.lastName}`;
      this.firstLetterOfName = cached.firstName.charAt(0).toUpperCase();
      return;
    }

    this.userDataSubscription = this.authenticationService.userDataSubject.subscribe((user: UserModel) => {
      if (user) {
        this.userName = `${user.FirstName} ${user.LastName}`;
        this.firstLetterOfName = this.getUserNameFirstLetter(user);
        this.email = user.EncryptedEmail;
        this.authenticationService.setCookieUserName(user.FirstName, user.LastName);
      }
    });
  }

  getUserNameFirstLetter(user: UserModel): string {
    return user.FirstName ? user.FirstName.charAt(0).toUpperCase() : '';
  }
  getUsername() {
    return this.userName;
  }

  getTitle() {
    return this.notifierService.getCurrentTitle();
  }

  getVersion() {
    return environment.VERSION;
  }

  showUserProfile() {
    let popupInput = {
      FamilyProjectId: '0',
      ProjectName: "",
      viewMode: 2
    }
    this.dialogService.setHalf().open("UserProfileMain", popupInput).subscribe(res => {
      if (res.data == "success") {
        // window.location.href = "#0";
      }
    })
  }

  showPreferences() {
    let popupInput = {
      FamilyProjectId: '0',
      ProjectName: "",
      viewMode: 2
    }
    this.dialogService.setHalf().open("PreferenceMain", popupInput).subscribe(res => {
      if (res.data == "success") {
        window.location.href = "#0";
      }
    })
  }

  showAboutUs() {
    let popupInput = {
      viewMode: 1
    }
    this.dialogService.setHalf().open("AboutUs", popupInput).subscribe(res => {
      console.log(res);
    })
  }

  showShoppingCart() {
    this.authenticationService.setCookieShop(true);
    let url = environment.WEB_SHOP_MEMBERSHIP_URL.replace("{0}", this.authenticationService.getUser().CustomerId);
    window.location.href = url;
  }

  openTab(url: string) {
    window.open(url, "_blank");
  }

  getEnvironment() {
    return environment;
  }

  logout() {
    this.authenticationService.removeCookieUserName();
    this.authenticationService.logout();
  }

  search(ele) {
    console.log(ele);
    console.log(ele.value);
  }

  notify() {
    this.refreshSearchResults();
  }

  refreshSearchResults() {
    if (!(this.searchResults?.projectId === this.projectRefService.getCurrentProject()?.familyProjectId))
      this.searchResults = { data: [], projectId: "" };
  }
  /** ------------------------ show lists -------------------------------------- */

  // Title map for list translation
  titleMap = new Map<string, string>(
    [
      ["Multimedia", "lbl_media_list"], // Todo: need translate
      ["Place", "lbl_place_list"],
      ["Source", "lbl_source_list"],
      ["IndividualMain", "lbl_persons_list"],
      ["ReportsMenu", "lbl_reports"],
    ]
  );

  // Show listing pops //Place//Multimedia//Individuals//Source
  openPopup(name: string) {

    let projectName = this.projectRefService.getCurrentProject().projectName;

    let mainTitle = this.titleMap.get(name);
    this.dialogService.setFull().open(name, {
      id: 0,
      reference: {
        id: 0,
        type: ReferenceType.None,
        rawData: ""
      },
      title: this.translateHandler.translate('lbl_menu_list_title', [this.translateHandler.translate(mainTitle), projectName]) ?? "",
      mediaType: [MultimediaTypes.PHOTO, MultimediaTypes.DOC, MultimediaTypes.AUDIO, MultimediaTypes.VIDEO],
      viewMode: PopupViewMode.GalleryView, // Gallery or editor view
      editMediaId: 0, // MediaId which supposes to be edited
      editSourceId: 0,
      isStandAlone: true,
      mode: PopupOpenMode.List, // Todo: Make a enum
      showMode: [1]
    }
    )
      .subscribe(response => {
        if (response != null && response.data) {
          this.router.navigate([AppConstatnts.routerModes.TreeEditor]);
        }
      });
  }

  openSupportPopup() {
    this.dialogService.setHalf().open('Support', { name: this.userName, email: this.email });
  }

  getFtHelpRoute(route: string) {
    return `${route}?lang=${this.translateService.currentLang}`
  }

  getEditorModes(): typeof EditorMode {
    return EditorMode;
  }

  openEditor(editorMode: EditorMode) {
    let ref: EditorReferenceInfo = {
      id: (editorMode === EditorMode.FamilyEditor) ? this.notifierService.getCurrentRootFamilyId() : this.notifierService.getCurrentRootMemberId(),
      isBreadcrumbUpdate: true,
    }
    this.notifierService.openEditor(editorMode, ref);
  }

  openResourceEditor(editorMode: EditorMode) {
    let ref: EditorReferenceInfo = {
      id: 0,
      isBreadcrumbUpdate: true,
    }
    this.notifierService.openEditor(editorMode, ref);
  }

  ngOnDestroy(): void {
    if (this.userDataSubscription) {
      this.userDataSubscription.unsubscribe();
    }
  }

  toggleSupportPopup() {
    this.showSupportPopup = !this.showSupportPopup;
  }
}
